import request from 'utils/request'

export const getMCAXS581InitRequest = () =>
  request({
    url: '/MCAXS581/init',
    method: 'post',
  })
